import React, { useState, useRef, useMemo } from 'react';
import { Accordion, FloatingLabel, Stack } from 'react-bootstrap';
import _ from 'lodash';
import classNames from 'classnames';
import { Icon, Button, PaymentError } from 'lb-components';
import Confirm from './sms';

import classes from '../Manual.module.scss';
import {
  AddCard,
  Card,
  Info,
  NoAddCard,
} from 'lb-components/src/stories/assets/icons/payment';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import { Loader } from '../../Loader';

const bankColors = {
  BOG: '#FF671B',
  TBC: '#00ABED',
  LIB: '#E70D2F',
};
const withdrawFee = 6;
const calcWithdrawFee = 0.06
const limits = {
  deposit: {
    LEADER_CARD: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
    },
    BOG: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
    },
    TBC: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
    },
    ANY: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
    },
  },
  withdraw: {
    LEADER_CARD: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
      fee: withdrawFee,
    },
    BOG: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
      fee: withdrawFee,
    },
    TBC: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
      fee: withdrawFee,
    },
    ANY: {
      min: '1',
      max: '50 000',
      maxAmount: '200 000',
      fee: withdrawFee,
    },
  },
};

export default ({
  platform,
  eventKey,
  logo,
  cardOptions,
  submit,
  panConverter,
  actionType,
  balance,
  t,
  ...props
}) => {
  //console.log(eventKey);
  const [sync, setSync] = useState(true);
  const formRef = useRef();
  const cardRef = useRef();
  const amountRef = useRef();
  const fullAmountRef = useRef();
  const [error, setError] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [data, setData] = useState({});
  const [smsError, setSmsError] = useState('');
  const [resend, setResend] = useState(false);
  const [loader, setLoader] = useState(false);

  const resendTimerRef = useRef();

  const submitHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();

    clearTimeout(resendTimerRef.current);

    if (actionType === 'deposit' && eventKey === 'LEADER_CARD') {
      setTimeout(() => {
        window.open('https://leadercard.ge/ka', '_blank');
      }, 1);
      return;
    }
    amountRef?.current?.blur();

    let updatedError = {};
    if (eventKey !== 'LEADER_CARD') {
      if (
        _.isNil(event.target?.cardId.dataset?.id) ||
        event.target?.cardId.dataset?.id?.trim() === ''
      )
        //updatedError.cardId = 'ბარათი არასწორად არის მითითებული';
        updatedError.cardId =
          actionType === 'withdraw' && cardOptions.length === 0
            ? 'თანხის გასატანად, დააფიქსირეთ ბარათიდან მინიმუმ ერთი ჩარიცხვა'
            : 'ბარათი არასწორად არის მითითებული';
    }

    if (isNaN(parseFloat(event.target?.amount.value)))
      updatedError.amount = 'თანხა არასწორად არის მითითებული';
    setError(updatedError);
    if (_.isEmpty(updatedError)) {
      let amount = parseFloat(event.target.amount.value);
      if(actionType === 'withdraw'){
        amount = (parseFloat(event.target.amount.value) / (1 - calcWithdrawFee)).toFixed(2);
      }
      const formData = {
        cardId:
          eventKey === 'LEADER_CARD' ? sync : event.target.cardId.dataset.id,
        amount: amount,
        //amount: parseFloat(event.target.amount.value),
        provider: eventKey === 'ANY' ? 'TBC' : eventKey,
        sms: event.target.sms?.value,
        confirm: confirm,
        loader: setLoader,
      };

      if (actionType === 'deposit') {
        submit(formData, (callback) => {});
      } else {
        submit(formData, (callback) => {
          if (callback?.confirm) {
            setConfirm(callback?.confirm);
          }
          if(callback?.left){
            resendTimerRef.current = setTimeout(() => {
              setResend(true);
            }, callback.left * 1000);
          }
          if (callback?.sms) {
            setSmsError(callback.sms);
          }
          if (callback?.nbcSync !== undefined) {
            setSync(callback?.nbcSync);
          }
        });
        setData(formData);
      }

      //if result.error setError(result.error), else:
    }
  };

  const hotMoney = (m) => {
    if (m > 50000) m = 50000;

    if (m < 10)
      return [
        { key: '2', value: 2 },
        { key: '5', value: 5 },
        { key: '10', value: 10 },
      ];

    const r = Math.pow(10, parseInt(m).toString().length - 1);
    const n = Math.trunc(m / r) * r;
    const arr = [0.2, 0.5, 1];
    const res = [];

    for (let el of arr) {
      let amount = Math.round(el * n);
      res.push({ key: amount.toString(), value: amount });
    }
    return res;
  };
  const amountOptions = useMemo(() => {
    if (actionType === 'deposit')
      return [
        { key: '20', value: 20 },
        { key: '50', value: 50 },
        {
          key: '100',
          value: 100,
        },
        { key: 'MAX', value: 50000 },
      ];

    return [
      ...hotMoney((balance * (1-calcWithdrawFee))),
      { key: (balance * (1-calcWithdrawFee)).toFixed(2), value: (balance * (1 - calcWithdrawFee)) },
    ];
  }, [actionType, balance]);

  const getNotifyText = (obj) => {
    console.log(obj,1212);
  }

  return (
    <Accordion.Item
      eventKey={eventKey}
      className={classNames(classes.container, classes[platform])}
      {...props}
    >
      {React.createElement(
        platform === 'web' ? 'div' : Accordion.Header,
        {
          className: classes.header,
          /*...(platform === 'mob' && {
            onClick: () => {
              formRef.current?.reset();
              setConfirm(false);
              setError({});
              setData({});
            },
          }),*/
        },
        <>
          <div
            className={classNames({
              [classes.logo]: true,
              [classes.any]: eventKey === 'ANY',
            })}
            data-label={eventKey === 'ANY' ? t('ნებისმიერი ბარათით') : ''}
            style={{ backgroundImage: `url(${logo})` }}
          />

          <div className={classes.info} onClick={(e) => e.stopPropagation()}>
            <Icon
              Icon={Info}
              type={'vec'}
              height={'100%'}
              width={'100%'}
              style={{
                maskSize: '90%',
                WebkitMaskSize: '90%',
                backgroundColor: _.isEmpty(error)
                  ? '#5C74A5'
                  : 'var(--bs-danger)',
              }}
            />
            <p className={classes.message}>
              {
                actionType === 'deposit'
                ? t('მინიმუმ, მაქსიმუმ')
                    .replace('${min}', limits[actionType][eventKey].min)
                    .replace('${max}', limits[actionType][eventKey].max)
                    .replace('${maxAmount}', limits[actionType][eventKey].maxAmount)
                : t('მინიმუმ, მაქსიმუმ, საკომისიო')
                    .replace('${min}', limits[actionType][eventKey].min)
                    .replace('${max}', limits[actionType][eventKey].max)
                    .replace('${maxAmount}', limits[actionType][eventKey].maxAmount)
                    .replace('${fee}', limits[actionType][eventKey].fee)
              }
            </p>
          </div>
        </>
      )}
      {React.createElement(
        platform === 'web' ? 'div' : Accordion.Body,
        { className: classes.body },
        <>
          {confirm ? (
            <Confirm
              t={t}
              loader={loader}
              smsError={smsError}
              platform={platform}
              resend={resend}
              onResend={() => {
                setResend(false);
                submit(
                  {
                    ...data,
                    sms: undefined,
                    confirm: confirm,
                    loader: setLoader,
                  },
                  (callback) => {
                    if (callback?.sms) {
                      setSmsError(callback.sms);
                    }
                    if(callback?.left){
                      resendTimerRef.current = setTimeout(() => {
                        setResend(true);
                      }, callback.left * 1000);
                    }
                    if (callback?.confirm !== undefined) {
                      setConfirm(callback.confirm);
                    }
                  }
                );
              }}
              submit={(formData) =>
                submit(
                  {
                    ...data,
                    sms: formData.sms,
                    confirm: confirm,
                    loader: setLoader,
                  },
                  (callback) => {
                    if (callback?.sms) {
                      setSmsError(callback.sms);
                    }
                    if (callback?.confirm !== undefined) {
                      setConfirm(callback.confirm);
                    }
                  }
                )
              }
              /*resend={() => ({ timeout: 10 })}*/
            />
          ) : (
            <Row
              as={Form}
              noValidate
              autoComplete={'off'}
              ref={formRef}
              onSubmit={submitHandler}
              /*onBlur={() => {
                if (platform === 'web' && !_.isEmpty(error)) setError({});
              }}*/
            >
              {eventKey === 'LEADER_CARD' && actionType === 'deposit' ? (
                <></>
              ) : (
                <>
                  {eventKey == 'LEADER_CARD' ? (
                    <Col xs={5}>
                      <Form.Check
                        className={'switch-button'}
                        type='switch'
                        name={'cardId'}
                        id={`default-checkbox`}
                        label={t(
                          'გსურთ ლიდერბეთის ბალანსის ენბისის ბარათთან სინქრონიზაცია?'
                        )}
                        checked={sync}
                        onChange={(e) => {
                          setSync(e.target.checked);
                        }}
                      />
                    </Col>
                  ) : (
                    <Col xs={5}>
                      <>
                        <div className={classes.dropdown} tabIndex={0}>
                          <Form.Group className={classes.formGroup}>
                            {React.createElement(
                              platform === 'web'
                                ? React.Fragment
                                : FloatingLabel,
                              {
                                ...(platform === 'mob' && {
                                  label: t('ბარათი'),
                                  style: {
                                    width: '100%',
                                    color: '#868895',
                                  },
                                  className: classes.floatingLabel,
                                }),
                              },
                              <Form.Control
                                isInvalid={error?.cardId}
                                name={'cardId'}
                                ref={cardRef}
                                disabled
                                defaultValue={t('აირჩიეთ ბარათი')}
                              />
                            )}
                            {platform === 'mob' && !!error.cardId && (
                              <Form.Label>{t(error.cardId)}</Form.Label>
                            )}
                          </Form.Group>
                          <div className={classes.menu}>
                            {actionType === 'deposit' && (
                              <>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (error.cardId)
                                      setError(_.omit(error, 'cardId'));
                                    cardRef.current.value = t(
                                      'ახალი ბარათი შენახვით'
                                    );
                                    cardRef.current.style.backgroundColor =
                                      '#fff';
                                    cardRef.current.dataset.id = 1;
                                    document.activeElement.blur();
                                  }}
                                >
                                  <Icon
                                    Icon={AddCard}
                                    style={{
                                      height: '1.7rem',
                                      width: '1.7rem',
                                      marginRight: '1rem',
                                    }}
                                  />
                                  <span>{t('ახალი ბარათი შენახვით')}</span>
                                </div>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (error.cardId)
                                      setError(_.omit(error, 'cardId'));
                                    cardRef.current.value = t(
                                      'ახალი ბარათი შენახვის გარეშე'
                                    );
                                    cardRef.current.style.backgroundColor =
                                      '#fff';
                                    cardRef.current.dataset.id = 0;
                                    document.activeElement.blur();
                                  }}
                                >
                                  <Icon
                                    Icon={NoAddCard}
                                    style={{
                                      height: '1.7rem',
                                      width: '1.7rem',
                                      marginRight: '1rem',
                                    }}
                                  />
                                  <span>
                                    {t('ახალი ბარათი შენახვის გარეშე')}
                                  </span>
                                </div>
                              </>
                            )}
                            {cardOptions.map((item) => (
                              <div
                                key={item.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (error.cardId)
                                    setError(_.omit(error, 'cardId'));
                                  cardRef.current.value = _.flatten(
                                    _.map(panConverter(item.pan), (v) => {
                                      return v.concat(' ');
                                    })
                                  ).join('');
                                  cardRef.current.style.backgroundColor =
                                    '#fff';
                                  cardRef.current.dataset.id = item.id;
                                  document.activeElement.blur();
                                }}
                              >
                                <Icon
                                  Icon={Card}
                                  type={'vec'}
                                  style={{
                                    height: '2rem',
                                    width: '2rem',
                                    marginRight: '1rem',
                                    backgroundColor: bankColors[item.bankID],
                                  }}
                                />
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    paddingRight: '3rem',
                                  }}
                                >
                                  {_.map(panConverter(item.pan), (v, k) => {
                                    return (
                                      <div
                                        key={k}
                                        className={`${
                                          k === panConverter(item.pan) - 1
                                            ? classes.visible
                                            : ''
                                        }`}
                                      >
                                        {v}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ))}
                          </div>
                          {platform === 'web' && (
                            <PaymentError
                              show={!!error?.cardId}
                              message={t(error?.cardId)}
                            />
                          )}
                        </div>
                      </>
                    </Col>
                  )}

                  <Col xs={4} className={classes.amountContainer} tabIndex={0}>
                    <div className={classes.popover}>
                      {actionType === 'withdraw' && (
                        <FloatingLabel
                          label={t('ანგარიშიდან ჩამოგეჭრებათ')}
                          className={classes.floatingLabel}
                        >
                          <Form.Control
                            type='number'
                            name={'fullAmount'}
                            ref={fullAmountRef}
                            placeholder={t('ანგარიშიდან ჩამოგეჭრებათ')}
                            onChange={(e) => {
                              if (error.amount)
                                setError(_.omit(error, 'amount'));
                              amountRef.current.style.backgroundColor = '#fff';

                              const formattedVal =
                                e.target.value.split('.')[1]?.length > 2
                                  ? parseFloat(e.target.value).toFixed(2)
                                  : e.target.value;

                              /*fullAmountRef.current.value =
                                parseFloat(formattedVal) > parseFloat(balance)
                                  ? balance
                                  : formattedVal;*/

                              const newVal =
                                parseFloat(formattedVal) > parseFloat(balance)
                                  ? balance
                                  : formattedVal;
                              fullAmountRef.current.value = newVal;

                              amountRef.current.value = (parseFloat(newVal) * (1-calcWithdrawFee)).toFixed(
                                2
                              );
                            }}
                          />
                        </FloatingLabel>
                      )}

                      <div className={classes.border}>
                        {_.map(amountOptions, (i) => (
                          <button
                            key={i.key}
                            type={'button'}
                            className={i.key !== 'MAX' ? classes.number : null}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setError(_.omit(error, 'amount'));
                              amountRef.current.style.backgroundColor = '#fff';
                              amountRef.current.value = i.value.toFixed(2);
                              i.value = i.value || 0;
                              if (actionType === 'withdraw') {
                                fullAmountRef.current.value = (
                                    i.value / (1- calcWithdrawFee)
                                ).toFixed(2);
                              }
                            }}
                          >
                            {i.key}
                          </button>
                        ))}
                      </div>
                    </div>
                    <Form.Group
                      className={classes.formGroup}
                      style={{
                        display: platform === 'web' ? 'flex' : null,
                        alignItems: 'center',
                      }}
                    >
                      {React.createElement(
                        platform === 'web' ? React.Fragment : FloatingLabel,
                        {
                          ...(platform === 'mob' && {
                            label: t('თანხა'),
                            style: {
                              width: '100%',
                              color: '#868895',
                            },
                            className: classes.floatingLabel,
                          }),
                        },
                        <Form.Control
                          onChange={(e) => {
                            if (error.amount) setError(_.omit(error, 'amount'));
                            amountRef.current.style.backgroundColor =
                              e.target.value === '' ? '#E6E6E6' : '#fff';

                            const formattedVal =
                              e.target.value.split('.')[1]?.length > 2
                                ? parseFloat(e.target.value).toFixed(2)
                                : e.target.value;

                            const limit =
                              actionType === 'withdraw'
                                ? (parseFloat(balance) * (1-calcWithdrawFee)).toFixed(2)
                                : 50000;
                            const newVal =
                              parseFloat(formattedVal) > parseFloat(limit)
                                ? limit
                                : formattedVal;
                            amountRef.current.value = newVal;

                            if (actionType === 'withdraw') {
                              fullAmountRef.current.value = (
                                parseFloat(newVal) / (1- calcWithdrawFee)
                              ).toFixed(2);

                            }
                          }}
                          style={{
                            maxHeight: '3.6rem',
                          }}
                          type={'number'}
                          placeholder={t('თანხა')}
                          isInvalid={error?.amount}
                          name={'amount'}
                          ref={amountRef}
                        />
                      )}
                      {platform === 'mob' && !!error.amount && (
                        <Form.Label>{t(error.amount)}</Form.Label>
                      )}
                    </Form.Group>

                    {/*{platform === 'web' && (
                      <PaymentError
                        show={!!error?.amount}
                        message={error?.amount}
                      />
                    )}*/}
                  </Col>
                </>
              )}

              <Col xs={3} style={{ alignItems: 'center' }}>
                <Button
                  variant={'success'}
                  type={'submit'}
                  disabled={loader}
                  style={{
                    height: 'fit-content',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Loader loader={loader} />
                  <span>
                    {actionType === 'deposit' ? t('შევსება') : t('გატანა')}
                  </span>
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}
    </Accordion.Item>
  );
};
